import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import NProgress from 'nprogress';
// import 'nprogress/nprogress.css';
import pinia from '/@/stores/index';
import { storeToRefs } from 'pinia';
import { NextLoading } from '/@common/utils/loading';
import { useKeepALiveNames } from '/@/stores/keepAliveNames';
import { useRoutesList } from '/@/stores/routesList';
import { useThemeConfig } from '/@/stores/themeConfig';
import { useUserInfo } from '/@/stores/userInfo';
import { staticRoutes, notFoundAndNoPower } from '/@/router/route';
import { initFrontEndControlRoutes } from '/@/router/frontEnd';
import { initBackEndControlRoutes } from '/@/router/backEnd';
import { Session,Local } from '/@common/utils/storage';
import { UrlSearch } from '/@common/utils/utils.ts';
import { useLoginApi } from '/@/api/login';
import { useBasicLayout } from '/@common/hooks/useBasicLayout';
import Cookies from 'js-cookie';
const { isMobile } = useBasicLayout();
import other from '/@common/utils/other';

// const { isLoginApi, getInfoLogin } = useLoginApi();

/**
 * 1、前端控制路由时：isRequestRoutes 为 false，需要写 roles，需要走 setFilterRoute 方法。
 * 2、后端控制路由时：isRequestRoutes 为 true，不需要写 roles，不需要走 setFilterRoute 方法），
 * 相关方法已拆解到对应的 `backEnd.ts` 与 `frontEnd.ts`（他们互不影响，不需要同时改 2 个文件）。
 * 特别说明：
 * 1、前端控制：路由菜单由前端去写（无菜单管理界面，有角色管理界面），角色管理中有 roles 属性，需返回到 userInfo 中。
 * 2、后端控制：路由菜单由后端返回（有菜单管理界面、有角色管理界面）
 */

// 读取 `/src/stores/themeConfig.ts` 是否开启后端控制路由配置
const storesThemeConfig = useThemeConfig(pinia);
const storesUserInfo = useUserInfo(pinia);
const { themeConfig } = storeToRefs(storesThemeConfig);
const { isRequestRoutes } = themeConfig.value;

/**
 * 创建一个可以被 Vue 应用程序使用的路由实例
 * @method createRouter(options: RouterOptions): Router
 * @link 参考：https://next.router.vuejs.org/zh/api/#createrouter
 */
export const router = createRouter({
	history: createWebHashHistory(),
	// history: createWebHistory(`/${import.meta.env.VITE_APP_NAME}`),
	/**
	 * 说明：
	 * 1、notFoundAndNoPower 默认添加 404、401 界面，防止一直提示 No match found for location with path 'xxx'
	 * 2、backEnd.ts(后端控制路由)、frontEnd.ts(前端控制路由) 中也需要加 notFoundAndNoPower 404、401 界面。
	 *    防止 404、401 不在 layout 布局中，不设置的话，404、401 界面将全屏显示
	 */
	routes: [...notFoundAndNoPower, ...staticRoutes],
});

/**
 * 路由多级嵌套数组处理成一维数组
 * @param arr 传入路由菜单数据数组
 * @returns 返回处理后的一维路由菜单数组
 */
export function formatFlatteningRoutes(arr: any) {
	if (arr.length <= 0) return false;
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].children) {
			arr = arr.slice(0, i + 1).concat(arr[i].children, arr.slice(i + 1));
		}
	}
	return arr;
}

/**
 * 一维数组处理成多级嵌套数组（只保留二级：也就是二级以上全部处理成只有二级，keep-alive 支持二级缓存）
 * @description isKeepAlive 处理 `name` 值，进行缓存。顶级关闭，全部不缓存
 * @link 参考：https://v3.cn.vuejs.org/api/built-in-components.html#keep-alive
 * @param arr 处理后的一维路由菜单数组
 * @returns 返回将一维数组重新处理成 `定义动态路由（dynamicRoutes）` 的格式
 */
export function formatTwoStageRoutes(arr: any) {
	if (arr.length <= 0) return false;
	const newArr: any = [];
	const cacheList: Array<string> = [];
	arr.forEach((v: any) => {
		if (v.path === '/') {
			newArr.push({ component: v.component, name: v.name, path: v.path, redirect: v.redirect, meta: v.meta, children: [] });
		} else {
			// 判断是否是动态路由（xx/:id/:name），用于 tagsView 等中使用
			if (v.path.indexOf('/:') > -1) {
				v.meta['isDynamic'] = true;
				v.meta['isDynamicPath'] = v.path;
			}
			newArr[0].children.push({ ...v });
			// 存 name 值，keep-alive 中 include 使用，实现路由的缓存
			// 路径：/@common/layout/routerView/parent.vue
			if (newArr[0].meta.isKeepAlive && v.meta.isKeepAlive) {
				cacheList.push(v.name);
				const stores = useKeepALiveNames(pinia);
				stores.setCacheKeepAlive(cacheList);
			}
		}
	});
	return newArr;
}
const stores = useUserInfo();



// 路由加载前
router.beforeEach(async (to, from, next) => {
	const storesRoutesList = useRoutesList(pinia);
	// Session.set('token', 'Qt8Q3cB/uc2KTqnBPtJQAMO1zRDq2Iq4cee4Vf6Omjk=A&sYjVkODkwNTg2NmQ3ZDU0NDQ2N2E1N2NhMmQ4OGNlYWY=');
	storesRoutesList.setCurrentRoute(to);
	let shareId= to.params.shareId
	let shareAgentId= to.params.shareAgentId
	let ticket= to.params?.ticket
	const token = Session.get('token');
	let tokenKey = Cookies.get('TOKEN_KEY');
	// if (isMobile.value && !shareId && other.isMobile()&&!shareAgentId) {
	// 	const currentUrl = window.location.href;
	// 	// window.location.href = window.origin + '/download' + `?sourceUrl=${encodeURIComponent(currentUrl)}`
	// 	window.location.href = window.origin + '/chath5' + `?sourceUrl=${encodeURIComponent(currentUrl)}`
	// 	return false
	// 	tokenKey = token
	// }
	NProgress.configure({ showSpinner: false });
	if (to.meta.title) NProgress.start();
	let pathList=['/cooperation','/serviceAgreement','/privacyPolicy','/jsbridge-test','/chath5']
	if(pathList.includes(to.path)||shareId||shareAgentId||ticket){
		if(localStorage.getItem('nowLink')){
			await stores.isLogin();
		}
		next();
		return;
	}
	if (to.path === '/login' && !token) {
		next();
		NProgress.done();
	} else {
		const storesRoutesList = useRoutesList(pinia);
			const { routesList } = storeToRefs(storesRoutesList);
			if (routesList.value.length === 0) {
				if (isRequestRoutes) {
					// 后端控制路由：路由数据初始化，防止刷新时丢失
					await initBackEndControlRoutes();
					// 解决刷新时，一直跳 404 页面问题，关联问题 No match found for location with path 'xxx'
					// to.query 防止页面刷新时，普通路由带参数时，参数丢失。动态路由（xxx/:id/:name"）isDynamic 无需处理
					next({ path: to.path, query: to.query });
				} else {
					await initFrontEndControlRoutes();
					const url = window.location.href;
                    const params = new URL(url).searchParams;
                    const ticket = params.get('ticket');
					console.log(ticket,"ticket")
					if ((tokenKey && !token) || (!tokenKey && !token)||(token&&tokenKey&&token!=tokenKey)) {
						console.log(token,tokenKey,"设置用户信息等")
						const userName = Cookies.get('userName');
						const roleIdKey = `${userName}_roleId`;
						Local.set(roleIdKey, '');
						//第三方跳转携带ticket获取用户信息
						if(((!tokenKey && !token)||(tokenKey&&!token))&&ticket){
							await stores.getUrlTicket(ticket);
						}else{
							await stores.isLogin();
						}
						next('/')
					}
					next({ path: to.path, query: to.query });
				}
			} else {
				const phoneMd5 = Session.get('phoneMd5');
				const phoneNumber=Session.get('phoneNumber');
				console.log(phoneNumber,"chat微信登录手机号信息",token,tokenKey)
				if (phoneMd5 == '5gVyuHAI9kN1ESUKFqZ2bA==') {
					console.log("绑定手机号")
					//next('/login?t=b');
					window.location.href = `${window.$website.ADMIN_URL}/#/login?t=b`
					NextLoading.done();
				} else {
					console.log(stores.isLoginState,"登录成功")
					// 清除之前的body class
					document.body.className = '';

					// // 如果当前路由有设置body class，添加到body
					if (to.meta.bodyClass) {
						document.body.classList.add(to.meta.bodyClass);
					}
					next();
					NextLoading.done();
				}
			}
	}
});

// 路由加载后
router.afterEach(() => {
	NProgress.done();
});
// 路由报错
router.onError((error, to) => {
	if (error.message.includes('Failed to fetch dynamically imported module')) {
		window.history.pushState({}, '', import.meta.env.VITE_API_URL + '#' + to.path);
		window.location.reload();
	}
});

// 导出路由
export default router;
